"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableToolbar = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_intl_1 = require("react-intl");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Print_1 = __importDefault(require("@material-ui/icons/Print"));
const Cached_1 = __importDefault(require("@material-ui/icons/Cached"));
const ViewColumn_1 = __importDefault(require("@material-ui/icons/ViewColumn"));
const Sort_1 = __importDefault(require("@material-ui/icons/Sort"));
const FilterList_1 = __importDefault(require("@material-ui/icons/FilterList"));
const table_context_1 = require("./table-context");
const table_toolbar_button_1 = require("./table-toolbar-button");
const bulk_action_button_1 = require("./bulk-action-menu/bulk-action-button");
const named_settings_button_1 = require("./saved/named-settings-button");
function TableToolbar({ before, after }) {
    const { totalCount, loadedCount, tableName, filtersState, showRefreshButton, showColumnButton, showResetSortsButton, showFilterButton, showNamedSettingsButton, showReportButton, showBulkActionButton, disabledRefreshButton, disabledColumnButton, disabledResetSortsButton, disabledFilterButton, disabledNamedSettingsButton, disabledBulkActionButton, disabledReportButton, reportTag, bulkActions, refresh, openColumnDialog, openExportDialog, openFilterDialog, resetSorts, classes, } = react_1.useContext(table_context_1.TableContext);
    const { selected } = react_1.useContext(table_context_1.TableSelectedContext);
    const selectedCount = selected.length;
    const intl = react_intl_1.useIntl();
    const filterCount = filtersState.filter((filter) => filter.enabled).length;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: clsx_1.default(classes.toolbarWrapper, {
                [classes.toolbarSelected]: selectedCount > 0,
            }) },
            react_1.default.createElement(Typography_1.default, { className: classes.toolbarText, component: "span" }, selectedCount > 0 ? (react_1.default.createElement("span", { className: classes.toolbarSelectedLabel },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_TOOLBAR_SELECTED", defaultMessage: `{selectedCount, plural, 
                  one {1 vybraná položka}
                  few {# vybrané položky}
                  other {# vybraných položek}}`, values: { selectedCount } }))) : (react_1.default.createElement(react_1.default.Fragment, null, tableName !== null && tableName !== void 0 ? tableName : '',
                ` (${loadedCount}/${Math.max(totalCount, 0)})`))),
            react_1.default.createElement("ul", { className: classes.toolbarButtonList },
                before,
                showRefreshButton && (react_1.default.createElement(table_toolbar_button_1.TableToolbarButton, { label: react_1.default.createElement(Cached_1.default, null), disabled: disabledRefreshButton, onClick: refresh, tooltip: intl.formatMessage({
                        id: 'EAS_TABLE_TOOLBAR_BTN_REFRESH',
                        defaultMessage: 'Obnovit data',
                    }) })),
                showResetSortsButton && (react_1.default.createElement(table_toolbar_button_1.TableToolbarButton, { label: react_1.default.createElement(Sort_1.default, null), disabled: disabledResetSortsButton, onClick: resetSorts, tooltip: intl.formatMessage({
                        id: 'EAS_TABLE_TOOLBAR_BTN_RESET_SORTS',
                        defaultMessage: 'Obnovení výchozího řazení',
                    }) })),
                showColumnButton && (react_1.default.createElement(table_toolbar_button_1.TableToolbarButton, { label: react_1.default.createElement(ViewColumn_1.default, null), disabled: disabledColumnButton, onClick: openColumnDialog, tooltip: intl.formatMessage({
                        id: 'EAS_TABLE_TOOLBAR_BTN_COLUMN_DIALOG_OPEN',
                        defaultMessage: 'Nastavení sloupců',
                    }) })),
                showFilterButton && (react_1.default.createElement(table_toolbar_button_1.TableToolbarButton, { label: react_1.default.createElement(FilterList_1.default, null), disabled: disabledFilterButton, onClick: openFilterDialog, tooltip: intl.formatMessage({
                        id: 'EAS_TABLE_TOOLBAR_BTN_FILTER_DIALOG_OPEN',
                        defaultMessage: 'Nastavení filtrů',
                    }), endIcon: react_1.default.createElement(Typography_1.default, { className: clsx_1.default(classes.toolbarText, classes.toolbarTextSub, {
                            'Mui-disabled': disabledFilterButton,
                        }), component: "span" }, filterCount) })),
                showNamedSettingsButton && reportTag != null && (react_1.default.createElement(named_settings_button_1.NamedSettingsButton, { disabled: disabledNamedSettingsButton, tag: reportTag })),
                showBulkActionButton && (react_1.default.createElement(bulk_action_button_1.BulkActionButton, { disabled: disabledBulkActionButton || bulkActions.length === 0, actions: bulkActions })),
                showReportButton && (react_1.default.createElement(table_toolbar_button_1.TableToolbarButton, { label: react_1.default.createElement(Print_1.default, null), disabled: disabledReportButton, onClick: openExportDialog, tooltip: intl.formatMessage({
                        id: 'EAS_TABLE_TOOLBAR_BTN_EXPORT_DIALOG_OPEN',
                        defaultMessage: 'Export',
                    }) })),
                after))));
}
exports.TableToolbar = TableToolbar;
//# sourceMappingURL=table-toolbar.js.map